import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice';
import loadingReducer from './loader';
import categoryReducer from './categorySlice';
import dashboardReducer from './dashboardSlice';
import pageReducer from './pagesSlice';
import testSeriesReducer from './testSeriesSlice';
import mockTestReducer from './mockTestSlice';
import previousYearReducer from './PreviousYearSlice';
import lessonReducer from './lessonSlice';
import questionReducer from './questionSlice';
import settingReducer from './settingsSlice';
import faqReducer from './faqsSlice';
import slidesReducer from './slidersSlice';
import examUserReducer from './userExamSlice';
import examDetailsReducer from './ExamSlice';
import recordedClassReducer from './recordedClassSlice';
import recordedSubjectReducer from './recordedSubjectSlice';
import recordedChapterReducer from './recordedChapterSlice';
import recordedLessonsReducer from './recordedLessonsSlice';
import recordedQuestionReducer from './recordedQuestionsSlice';
import liveSubjectRouter from './liveSubjectSlice';
import liveChapterRouter from './liveChapterSlice';
import liveLessonRouter from './liveLessonsSlice';
import enoteSubjectReducer from './enotesSubjectSlice';
import enotesChapterReducer from './enotesChapterSlice';
import enotesLessonReducer from './enotesLessonsSlice';
import liveQuestionsReducer from './LiveQuestionsSlice';
import liveClassReducer from './liveClassSlice'
import subscriptionReducer from './subscriptionSlice';
import bodmasTestSeruesReducer from './bodmasTestSeriesSlice';
import bodmasCategoryReducer from './bodmasCategorySlice';
import bodmasTestLessonReducer from './bodmasTestLessonSlice';
import bodmasTestQuestionReducer from './bodmasTestQuestionSlice';
import teacherApplicationsReducer from './teacherApplicationsSlice';
import examinationReducer from './examinationSlice';
import gkShortsReducer from './gkShortsSlice';
import teachersReducer from './teachersSlice';
import teacherHoursReducer from './teacherHoursSlice';
import transactioniReducer from './transactionSlice';
import helpSupportReducer from './helpSupportSlice';
import enquiryReducer from './enquirySlice';
import enotesReducer from './enotesSlice';
import userreducer from './userSlice';
import couponReducer from './couponSlice';



export const store = configureStore({
  reducer: {
    auth: authReducer,
    loader: loadingReducer,
    category: categoryReducer,
    dashboard: dashboardReducer,
    page: pageReducer,
    testSeries: testSeriesReducer,
    mockTest: mockTestReducer,
    previousYear: previousYearReducer,
    lesson: lessonReducer,
    question: questionReducer,
    settings: settingReducer,
    faqs: faqReducer,
    sliders: slidesReducer,
    examUser: examUserReducer,
    examDetails: examDetailsReducer,
    subscription: subscriptionReducer,
    gkShorts: gkShortsReducer,
    teachers: teachersReducer,
    teacherHours: teacherHoursReducer,
    transactions: transactioniReducer,
    helpSupport: helpSupportReducer,
    enquiry: enquiryReducer,
    user: userreducer,
    coupons: couponReducer,




    recordedClass: recordedClassReducer,
    recordedSubject: recordedSubjectReducer,
    recordedChapter: recordedChapterReducer,
    recordedLessons: recordedLessonsReducer,
    recordedQuestion: recordedQuestionReducer,


    liveClass: liveClassReducer,
    liveSubject: liveSubjectRouter,
    liveChapter: liveChapterRouter,
    liveLesson: liveLessonRouter,
    liveQuestion: liveQuestionsReducer,

    enote: enotesReducer,
    enoteSubject: enoteSubjectReducer,
    enoteChapter: enotesChapterReducer,
    enoteLesson: enotesLessonReducer,


    bodmasCategory: bodmasCategoryReducer,
    bodmasTestseries: bodmasTestSeruesReducer,
    bodmasTestLesson: bodmasTestLessonReducer,
    bodmasTestQuestion: bodmasTestQuestionReducer,
    teacherApplications: teacherApplicationsReducer,
    examination: examinationReducer,
  },
})

export default store;